import React from 'react'
import type { TourStepProps } from 'antd'
import { Typography } from 'antd'
import { Layers, Calendar, Settings2 } from 'lucide-react'
import i18next from 'i18next'

const { Text, Paragraph } = Typography

const getElement = (selector: string) => () => document.querySelector<HTMLElement>(selector)!

const iconStyle = { verticalAlign: '-0.125em', marginRight: 8, opacity: 0.6 } as const

export const getCompanyLiteSteps = (): TourStepProps[] => [
  {
    title: i18next.t('tour:welcome'),
    description: <Paragraph>{i18next.t('tour:tips')}</Paragraph>
  },
  {
    target: getElement('.settings-menu'),
    title: i18next.t('tour:company-settings'),
    description: (
      <ol style={{ textAlign: 'left', paddingInlineStart: 20 }}>
        <li>
          <Text>{i18next.t('tour:add-users')}</Text>
        </li>
        <li>
          <Text>{i18next.t('tour:apis')}</Text>
        </li>
        <li>
          <Text>{i18next.t('tour:keyfigures')}</Text>
        </li>
      </ol>
    )
  },
  {
    target: getElement('.filter-toolbar'),
    title: i18next.t('tour:magnifier'),
    description: (
      <div style={{ textAlign: 'left' }}>
        <Paragraph>
          <Layers size={14} style={iconStyle} />
          {i18next.t('tour:dimensions')}
        </Paragraph>
        <Paragraph>
          <Calendar size={14} style={iconStyle} />
          {i18next.t('tour:date-filters')}
        </Paragraph>
        <Paragraph>
          <Settings2 size={14} style={iconStyle} />
          {i18next.t('tour:view-settings')}
        </Paragraph>
        <Paragraph style={{ marginBottom: 0 }}>
          <Settings2 size={14} style={iconStyle} />
          {i18next.t('tour:hide-empty-rows')}
        </Paragraph>
      </div>
    )
  },
  {
    target: getElement('.avatar-menu'),
    title: '',
    description: (
      <div>
        <Paragraph>{i18next.t('tour:user-manual')}</Paragraph>
        <Paragraph>{i18next.t('tour:questions')}</Paragraph>
        <Paragraph>{i18next.t('tour:greetings')}</Paragraph>
        <Text>{i18next.t('tour:team-finadeck')}</Text>
      </div>
    )
  }
]
